import { render } from "./skm.vue?vue&type=template&id=ffe0fa52&scoped=true"
import script from "./skm.vue?vue&type=script&lang=js"
export * from "./skm.vue?vue&type=script&lang=js"

import "./skm.vue?vue&type=style&index=0&id=ffe0fa52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe0fa52"]])

export default __exports__